export default "__VITE_ASSET__COVLA0Aw__"